import { createIcon as c } from "../createIcon.js";
const e = {
  name: "CheckIcon",
  height: 512,
  width: 448,
  svgPath: "M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z",
  yOffset: 0,
  xOffset: 0
}, o = c(e);
export {
  o as CheckIcon,
  e as CheckIconConfig,
  o as default
};
